import en from './en.json'
import fr from './fr.json'
import type { LocaleMessages } from './types'

const messages: LocaleMessages = {
	  en,
	      fr
}

export default messages
